


































































































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import gql from 'graphql-tag'

import AppCheckbox from '@/components/AppCheckbox.vue'
import { SnackType } from '@/interfaces/snack'
import { User } from '@/interfaces/user'
import { dispatchSignIn } from '@/store/dispatches'
import { showErrors, showNotification } from '@/utils/snack'
import { TypedGqlError } from '@/interfaces/error'
import { State } from 'vuex-class'
import { AuditStatus } from '@/interfaces/status'

@Component({
  components: {
    AppCheckbox
  }
})
export default class SignIn extends Vue {
  password = '';
  username = '';

  showPWD = false;

  rememberMe = true;

  rules = {
    required: (value: string, type: string) => !!value || type + '不能为空'
  };

  valid = true;

  get form (): Vue & { validate: () => boolean } {
    return this.$refs.form as Vue & { validate: () => boolean }
  }

  get version (): string {
    return process.env.VUE_APP_VERSION || ''
  }

  @State((state) => state.user.me) me!: User;

  validate () {
    if (this.form.validate()) {
      this.signIn()
    }
  }

  async signIn () {
    try {
      const result = await this.$apollo.mutate({
        mutation: gql`
          mutation ($phone: String!, $password: String!) {
            signIn(phone: $phone, password: $password) {
              createdAt
              dealer {
                id
                ifStoreOpening
                status
              }
              email
              id
              jwt
              phone
              role
              updatedAt
              username
            }
          }
        `,
        variables: {
          phone: this.username,
          password: this.password
        }
      })

      const me: User = result.data.signIn
      if (me) {
        if (me.role === 'DEALER') {
          if (me.dealer?.status !== AuditStatus.APPROVED) {
            showNotification({
              msg: '审核未通过',
              type: SnackType.Error
            })
            return false
          }
        }
        localStorage.setItem(
          process.env.VUE_APP_LOCAL_STORAGE_KEY as string,
          me.jwt + ''
        )
        sessionStorage.setItem('role', me.role)
        dispatchSignIn(me)
        showNotification({
          msg: '登录成功',
          type: SnackType.Success
        })
        setTimeout(() => {
          this.$router.push({ name: 'Home' })
        }, 1000)
      }
    } catch (e) {
      const typedError = e as TypedGqlError
      showErrors(typedError.graphQLErrors)
    }
  }
}
